import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Modal from "react-modal";
import { useGlobalContext } from "../../../Context/GlobalContext";
import ClipLoader from "react-spinners/ClipLoader";
import Cookies from "js-cookie";
import { saveAs } from "file-saver";

const PaymentHistory = () => {
  const {
    isLoading,
    openToast,
    baseUrl,
    staffs,
    fetchStaffs,
    setSelectedStaff,
  } = useGlobalContext();
  let subtitle;

  const [isOpen, setIsOpen] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [defaultMonth, setDefaultMonth] = useState("");
  const [loading, setLoading] = useState(false);

  const toggleAccordion = () => {
    setIsOpen((isOpen) => !isOpen);
  };

  const [toggleDrop, setToggleDrop] = useState(false);
  function handledrop() {
    setToggleDrop(!toggleDrop);
  }

  const [toggleDrop2, setToggleDrop2] = useState(false);

  function handledrop2() {
    setToggleDrop2(!toggleDrop2);
  }

  const [toggleDrop3, setToggleDrop3] = useState(false);

  function handledrop3() {
    setToggleDrop3(!toggleDrop3);
  }

  const [toggleDrop4, setToggleDrop4] = useState(false);

  function handledrop4() {
    setToggleDrop4(!toggleDrop4);
  }

  const [toggleDrop5, setToggleDrop5] = useState(false);

  function handledrop5() {
    setToggleDrop5(!toggleDrop5);
  }

  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleDrop = (dropdown) => {
    setActiveDropdown((prev) => (prev === dropdown ? null : dropdown));
  };

  const handleClickOutside = (event) => {
    if (!event.target.closest(".dropdown-container")) {
      setActiveDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  async function fetchPaymentHistory() {
    try {
      setLoading(true);
      const response = await fetch(
        `${baseUrl}payment/history/${year}/${month}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );
      if (response.status == 200) {
        const data = await response.json();
        setPaymentHistory(data);
      } else {
        openToast("An Error Occured", "Error");
      }
    } catch (error) {
      openToast("An Error Occured", "Error");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (paymentHistory?.data?.length == 0 && month !== "" && year !== "") {
      fetchPaymentHistory();
    }
  }, []);

  const handleMonthChange = (e) => {
    const value = e.target.value; // This gives the value in "YYYY-MM" format
    const [yearValue, monthValue] = value.split("-"); // Split the value into year and month
    setYear(yearValue);
    setMonth(monthValue);
  };
  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = String(now.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
    setDefaultMonth(`${currentYear}-${currentMonth}`);
    setYear(currentYear);
    setMonth(currentMonth);
  }, []);

  useEffect(() => {
    if (month === "" || year === "") {
      return;
    }
    fetchPaymentHistory();
  }, [month, year]);

  const exportToCSV = () => {
    // Prepare the CSV headers
    const headers = [
      "Index",
      "Name",
      "Payment Date",
      "Payment Type",
      "Status",
      "Amount Paid",
      "Transaction Id",
      "UTR No.",
      "Paid By",
      "Notes",
    ];

    // Map over the data to create CSV rows
    const rows = paymentHistory?.map((item, index) => [
      index + 1,
      item?.staff?.User?.name || "N/A",
      // item?.staffDetails?.job_title || "N/A",
      item?.date ? new Date(item.date).toLocaleDateString("en-GB") : "N/A",
      item?.type ?? "N/A",
      item?.status ?? "N/A",
      item?.amount ?? "N/A",
      item?.transactionId ?? "N/A",
      item?.utrNumber ?? "N/A",
      "N/A",
      item?.note ?? "N/A",
    ]);

    // Combine headers and rows for CSV format
    const csvData = [headers, ...rows].map((row) => row.join(",")).join("\n");

    // Create a Blob and download the file
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "PaymentHistory.csv");
  };

  return (
    <div className="mt-[20px]">
      <div className="flex lg:flex-row xl:flex-row flex-col md:flex-col items-center gap-[15px] lg:gap-[0px]">
        <div className="flex lg:flex lg:flex-row flex-col justify-around gap-[10px] lg:gap-[20px] w-full">
          <div className="xl:w-[220px]">
            <label htmlFor="" className="font-medium text-[14px]">
              Payroll Month
            </label>
            <input
              type="month"
              onChange={handleMonthChange}
              value={`${year}-${month}`}
              className="p-[8px] border rounded-md w-[100%] md:w-[100%] lg:w-[214px] text-sm focus-visible:outline-none"
            />
          </div>
          <div className="xl:w-[220px]">
            <label htmlFor="" className="font-medium text-[14px]">
              Company Branches
            </label>
            <select className="p-[8px] border rounded-md w-[100%] md:w-[100%] lg:w-[214px] text-sm focus-visible:outline-none">
              <option>All Branches</option>
              <option>Demo Main Branchs</option>
            </select>
          </div>
          <div className="xl:w-[220px]">
            <label htmlFor="" className="font-medium text-[14px]">
              Departments
            </label>
            <select className="p-[8px] border rounded-md w-[100%] md:w-[100%] lg:w-[214px] text-sm focus-visible:outline-none">
              <option>All Departments</option>
              <option>Website</option>
            </select>
          </div>
          <div className="xl:w-[220px]">
            <label htmlFor="" className="font-medium text-[14px]">
              Payment Mode
            </label>
            <select className="p-[8px] border rounded-md w-[100%] md:w-[100%] lg:w-[214px] text-sm focus-visible:outline-none">
              <option>All</option>
              <option>Google Pay</option>
            </select>
          </div>
        </div>
        <div className="flex justify-end items-center w-full">
          <button className="mt-[22px] second-btn">Reset</button>
        </div>
      </div>

      <div className="mt-5">
        <div className="flex md:flex-row flex-col justify-between items-center gap-[10px] mb-[20px] mainpayment">
          <div className="relative summary-border rounded-[10px] w-full lg:w-[240px] xl:w-[240px]">
            <input
              type="text"
              placeholder="Search"
              className="px-[10px] py-[9px] pr-[26px] pl-[10px] rounded-3xl text-[13px] client-add focus-visible:outline-none"
            />
            <SearchIcon className="top-[12px] right-[6px] absolute text-gray-500 newadd2" />
          </div>
          <div className="flex md:flex-row flex-col md:justify-end gap-[10px]">
            <button
              className="justify-center w-full md:w-auto second-btn"
              onClick={exportToCSV}
            >
              Download Report
            </button>
          </div>
        </div>
      </div>

      <div className="border-[#dcdbdb] bg-white shadow-cs border rounded-lg w-full h-[100%] overflow-x-auto">
        <table className="border-[#dcdbdb] border-collapse border rounded-lg w-full overflow-hidden table-auto">
          {/* Header with Toggle */}
          <thead
            className="border-gray-300 shadow-md border cursor-pointer"
            onClick={toggleAccordion}
          >
            <tr>
              {/* <th className="flex justify-center p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                #
              </th> */}

              <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                <div className="flex justify-center">
                  Name
                  <div className="relative dropdown-container">
                    <button onClick={() => handleDrop("name")}>
                      <FilterListIcon className="filter-icon" />
                    </button>

                    {activeDropdown === "name" && (
                      <div
                        className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                        tabIndex="-1"
                      >
                        <div className="py-1" role="none">
                          <Link
                            to="/add-one-staff"
                            className="block px-4 py-2 text-gray-700 text-sm"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-0"
                          >
                            Sort A to Z
                          </Link>
                          <Link
                            to="#"
                            className="block px-4 py-2 text-gray-700 text-sm"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-1"
                          >
                            Sort Z to A
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                <div className="flex justify-center">
                  Payment Date
                  <div className="relative dropdown-container">
                    <button onClick={() => handleDrop("payment")}>
                      <FilterListIcon className="filter-icon" />
                    </button>

                    {activeDropdown === "payment" && (
                      <div
                        className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                        tabIndex="-1"
                      >
                        <div className="py-1" role="none">
                          <Link
                            to="/add-one-staff"
                            className="block px-4 py-2 text-gray-700 text-sm"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-0"
                          >
                            Sort A to Z
                          </Link>
                          <Link
                            to="#"
                            className="block px-4 py-2 text-gray-700 text-sm"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-1"
                          >
                            Sort Z to A
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                <div className="flex justify-center">
                  Payment Type
                  <div className="relative dropdown-container">
                    <button onClick={() => handleDrop("p-type")}>
                      <FilterListIcon className="filter-icon" />
                    </button>

                    {activeDropdown === "p-type" && (
                      <div
                        className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                        tabIndex="-1"
                      >
                        <div className="py-1" role="none">
                          <Link
                            to="/add-one-staff"
                            className="block px-4 py-2 text-gray-700 text-sm"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-0"
                          >
                            Sort A to Z
                          </Link>
                          <Link
                            to="#"
                            className="block px-4 py-2 text-gray-700 text-sm"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-1"
                          >
                            Sort Z to A
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                <div className="flex justify-center">
                  Status
                  <div className="relative dropdown-container">
                    <button onClick={() => handleDrop("status")}>
                      <FilterListIcon className="filter-icon" />
                    </button>

                    {activeDropdown === "status" && (
                      <div
                        className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                        tabIndex="-1"
                      >
                        <div className="py-1" role="none">
                          <Link
                            to="/add-one-staff"
                            className="block px-4 py-2 text-gray-700 text-sm"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-0"
                          >
                            Sort A to Z
                          </Link>
                          <Link
                            to="#"
                            className="block px-4 py-2 text-gray-700 text-sm"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-1"
                          >
                            Sort Z to A
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                <div className="flex justify-center">
                  Amount Paid
                  <div className="relative dropdown-container">
                    <button onClick={() => handleDrop("amount")}>
                      <FilterListIcon className="filter-icon" />
                    </button>

                    {activeDropdown === "amount" && (
                      <div
                        className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                        tabIndex="-1"
                      >
                        <div className="py-1" role="none">
                          <Link
                            to="/add-one-staff"
                            className="block px-4 py-2 text-gray-700 text-sm"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-0"
                          >
                            Sort A to Z
                          </Link>
                          <Link
                            to="#"
                            className="block px-4 py-2 text-gray-700 text-sm"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-1"
                          >
                            Sort Z to A
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </th>
              <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                <div className="flex justify-center">Transaction ID</div>
              </th>

              <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                <div className="flex justify-center">UTR Number</div>
              </th>
              <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                <div className="flex justify-center">Paid By</div>
              </th>

              <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                <div className="flex justify-center">Notes</div>
              </th>
            </tr>
          </thead>

          <tbody className="w-full">
            {loading && (
              <tr className="h-[100px]">
                <td
                  colSpan="9"
                  className="border-[#dbdbdb] py-4 font-semibold text-center text-gray-600 text-xl whitespace-nowrap"
                >
                  <ClipLoader color="#24007a" size={50} />
                </td>
              </tr>
            )}
            {!loading &&
              paymentHistory?.data?.length > 0 &&
              paymentHistory?.data?.map((item, index) => {
                console.log(item)
                return (
                  <tr className="border">
                    <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                      <Link
                        onClick={() => setSelectedStaff(item)}
                        to={`/personal-detail/${item?.id}`}
                        className="font-medium text-[#8A25B0] cursor-pointer"
                      >
                        {item?.staff?.User?.name || "N/A"}
                      </Link>
                    </td>
                    <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                      {item?.date
                        ? new Date(item.date).toLocaleDateString("en-GB")
                        : "N/A"}
                    </td>
                    <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                      {item?.type ?? "N/A"}
                    </td>
                    <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                      {item?.status ?? "N/A"}
                    </td>
                    <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                      {item?.amount ?? "N/A"}
                    </td>
                    <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                      {item?.transactionId ?? "N/A"}
                    </td>
                    <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                      {item?.utrNumber ?? "N/A"}
                    </td>
                    <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                      {" "}
                      N/A
                    </td>
                    <td className="border-[#dbdbdb] p-[10px] border-r text-center text-xs whitespace-nowrap">
                      {item?.note == "" ? "N/A" : item?.note}
                    </td>
                  </tr>
                );
              })
            }

            {
              !loading && paymentHistory?.data?.length == 0 ? <tr className="h-[100px]">
                <td
                  colSpan="9"
                  className="border-[#dbdbdb] py-4 text-[15px] text-black text-center whitespace-nowrap f"
                >
                  No Record Found
                </td>
              </tr> : ""
            }
          </tbody>
          {/* 
          <div className="w-full">
            <h2 className="p-[10px] pl-0 whitespace-nowrap">Grand Total</h2>
          </div> */}
        </table>
      </div>
      <div className="w-full">
        <h2 className="p-[10px] pl-2 whitespace-nowrap">Grand Total</h2>
      </div>
    </div>
  );
};

export default PaymentHistory;
